"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = require("lodash");
/**
 * Tab
 * @block
 */
const Tab = ({ title, id, children, className, classNames = [], }) => {
    const tabID = id || (0, lodash_1.kebabCase)(title);
    return (react_1.default.createElement("div", { className: className || (0, classnames_1.default)('tab-pane', ...classNames), "data-title": title, id: tabID, role: "tabpanel", "aria-labelledby": `${tabID}-tab` }, children));
};
exports.default = Tab;
